import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

type TableBodyStyleProps = {
  cellPadding: string | number;
};

export const useTableBodyStyles = makeStyles<Theme, TableBodyStyleProps>(theme => ({
  padding: props => ({ padding: `${props.cellPadding} !important` }),
  expandableContentCell: {
    padding: '0 !important',
  },
  noBottomBorder: {
    borderBottom: 'unset',
  },
  stickyCell: {
    position: 'sticky',
    left: 0,
    right: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 2,
  },
  skeletonCell: {
    verticalAlign: 'middle',
  },
  skeletonExpandCell: {
    width: 48,
    verticalAlign: 'middle',
  },
}));
